import { create } from '@bufbuild/protobuf'
import { PaginationFiltersSchema } from '@/generated/Messages/Common_pb'

/**
 * Helper to calculate the pagination filters needed for api cals.
 * @param pageSize
 * @param page
 * @returns
 */
export const createPaginationFilters = (pageSize: number, page: number) =>
    create(PaginationFiltersSchema, {
        takeItemCount: pageSize,
        skipItemCount: page * pageSize,
    })
